export const LOGIN='LOGIN';
export const LOGOUT='LOGOUT';

export const CREATE_CARD='CREATE_CARD';
export const GET_CARD='GET_CARD';
export const DELETE_CARD='DELETE_CARD';
export const UPDATE_CARD='UPDATE_CARD';
export const GET_CARD_BY_ID='GET_CARD_BY_ID';

export const ADD_CARD_DATA='ADD_CARD_DATA';
export const GET_CARD_DATA='GET_CARD_DATA';
export const DELETE_CARD_DATA='DELETE_CARD_DATA';
export const UPDATE_CARD_DATA='UPDATE_CARD_DATA';

export const ADD_STEPS='ADD_STEPS';
export const GET_STEPS='GET_STEPS';
export const DELETE_STEPS='DELETE_STEPS';
export const UPDATE_STEPS='UPDATE_STEPS'

export const GET_USERS='GET_USERS';